import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import { mergeSxProps } from '@infl-ts/util-merge-sx-props';
import { Box, CardContent, Divider, styled, Typography } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var CardContentWrapper = styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .MuiCardContent-root:last-child {\n    padding: 0;\n  }\n"])));
var CONTENT_MARGIN = 3;

var HeaderFooter = function HeaderFooter(_ref) {
  var children = _ref.children,
      noPadding = _ref.noPadding,
      sx = _ref.sx,
      contentSx = _ref.contentSx;
  return /*#__PURE__*/_jsx(Box, {
    sx: mergeSxProps({
      margin: noPadding ? 0 : CONTENT_MARGIN
    }, contentSx),
    "data-element": "Box",
    "data-component": "HeaderFooter",
    "data-source-file": "index.tsx",
    children: typeof children === 'string' ? /*#__PURE__*/_jsx(Typography, {
      sx: sx,
      variant: "h3",
      children: children
    }) : children
  });
};

export var BlockCardContent = function BlockCardContent(_ref2) {
  var heading = _ref2.heading,
      headingNoPadding = _ref2.headingNoPadding,
      headingNoDivider = _ref2.headingNoDivider,
      headingSx = _ref2.headingSx,
      footer = _ref2.footer,
      footerNoPadding = _ref2.footerNoPadding,
      footerNoDivider = _ref2.footerNoDivider,
      children = _ref2.children,
      childrenNoPadding = _ref2.childrenNoPadding,
      noPadding = _ref2.noPadding;
  return /*#__PURE__*/_jsx(CardContentWrapper, {
    "data-element": "CardContentWrapper",
    "data-component": "BlockCardContent",
    "data-source-file": "index.tsx",
    children: /*#__PURE__*/_jsxs(CardContent, {
      "data-element": "CardContent",
      "data-component": "BlockCardContent",
      "data-source-file": "index.tsx",
      children: [heading ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(HeaderFooter, {
          contentSx: headingSx,
          sx: {
            textAlign: 'start'
          },
          noPadding: noPadding !== null && noPadding !== void 0 ? noPadding : headingNoPadding,
          children: heading
        }), headingNoDivider ? null : /*#__PURE__*/_jsx(Divider, {})]
      }) : null, /*#__PURE__*/_jsx(Box, {
        sx: {
          margin: noPadding || childrenNoPadding ? 0 : CONTENT_MARGIN
        },
        "data-element": "Box",
        "data-component": "BlockCardContent",
        "data-source-file": "index.tsx",
        children: children
      }), footer ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [footerNoDivider ? null : /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(HeaderFooter, {
          noPadding: noPadding !== null && noPadding !== void 0 ? noPadding : footerNoPadding,
          children: footer
        })]
      }) : null]
    })
  });
};